/**
 * Padel USA — tab switching for the homepage tabbed shelves (<product-list-tabs> in
 * sections/homepage-playstyle_custom.liquid and sections/homepage-popular_custom.liquid).
 * WAI-ARIA tabs with automatic activation: click, arrow keys, Home/End (horizontal or vertical lists).
 * Panels are pre-rendered by Liquid; this only toggles `hidden` and the roving tabindex.
 * Dossier: custom-code-padelusa/features/homepage-recommended-order.md
 */
class ProductListTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (!this.tabs.length) return;
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.select(tab);
  };

  onKeydown = (event) => {
    const index = this.tabs.indexOf(event.target);
    if (index === -1) return;
    let next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = this.tabs[(index + 1) % this.tabs.length];
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
    else if (event.key === 'Home') next = this.tabs[0];
    else if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    this.select(next);
    next.focus();
  };

  select(activeTab) {
    for (const tab of this.tabs) {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('product-list-tabs')) customElements.define('product-list-tabs', ProductListTabs);
